export default "__VITE_PUBLIC_ASSET__82f0109f__"